import { Form, Select } from 'antd';
import React, { FC, ReactElement, useState } from 'react';
import { useForm } from 'antd/es/form/Form';
import style from './index.module.scss';

type TProps = {
  selectOptions: Record<string, { name: string; alias: string; node: ReactElement | null }>;
};

enum FormValues {
  SELECT_OPTIONS = 'selectOptions',
}

const SearchComponent: FC<TProps> = ({ selectOptions }) => {
  const [form] = useForm();
  const [optionsSearch, setOptionsSearch] = useState<string>(selectOptions[Object.keys(selectOptions)[0]].name || '');
  const [currentNode, setCurrentNode] = useState<ReactElement | null>(
    selectOptions[Object.keys(selectOptions)[0]].node,
  );

  const onSelectOptionsSearch = (value: string) => {
    setOptionsSearch(value);
    setCurrentNode(selectOptions[value].node);
    Object.values(selectOptions).forEach(val => {
      form.setFieldValue(val.name, '');
    });
  };

  return (
    <Form form={form} className={style.searchWrap} initialValues={{ selectOptions: optionsSearch }}>
      <Form.Item name={FormValues.SELECT_OPTIONS}>
        <Select placeholder="Параметры поиска" className={style.selectDivisions} onSelect={onSelectOptionsSearch}>
          {Object.keys(selectOptions).map(elem => {
            return (
              <Select.Option key={selectOptions[elem].name} value={selectOptions[elem].name}>
                {selectOptions[elem].alias}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
      {currentNode}
    </Form>
  );
};

export default SearchComponent;
